export class AvatarConstants {
  public static readonly DEFAULT_AVATAR_URL: string = 'assets/icons/j-avatar.svg';
}
